import { Box, Grid, styled } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../../constants/theme";
import { imagesWEBP } from "../../../constants/webpImages";
import { Context } from "../../../context/context";
const CustomBanner = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  width: "100vw",
  paddingTop: "16px",
  ".blank-box": {
    width: "100%",
    background: primary.inactiveState,
    height: "80px",
  },
  ".search-bar-container": {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    top: "-32px",
    width: "40%",
  },
  ".search-bar-container.sticky": {
    position: "sticky",
    top: "80px",
    borderRadius: "100px",
    position: "sticky",
    zIndex: 1,
    backgroundColor: primary.white,
  },
  ".back_arrow": {
    display: "none",
  },

  ".banner-container": {
    width: "100vw",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    marginBottom: "20px",
  },
  ".banner1": {
    width: "84%",
    objectFit: "contain",
    // height: "13rem",
    // minHeight: "8rem",
    // maxHeight:"200px",
    justifySelf: "center",
  },
  ".banner2": {
    display: "none",
  },
  ".banner1img": {
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    ".search-bar-container": {
      width: "80%",
    },
    ".back_arrow": {
      display: "none",
    },
    ".banner-container": {
      width: "100%",
      //height: "128px",
      justifyContent: "center",
    },
    ".banner1": {
      width: "98%",
      height: "128px",
      justifySelf: "center",
    },
    ".banner2": {
      display: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".search-bar-container": {
      gap: "1rem",
      padding: "0 18px",
      width: "100%",
      top: "-32px",
    },
    ".search-bar-container.sticky": {
      top: "32px",
      position: "sticky",
      zIndex: 1,
      backgroundColor: primary.white,
      marginBottom: "16px",
    },
    ".back_arrow": {
      display: "block",

      background: primary.lightPink,

      width: "55px",
      textAlign: "center",
      borderRadius: "100px",
      height: "55px",
      padding: "10px 8px 10px 20px ",
      justifySelf: "flex-start",
    },
    ".blank-box": {
      background: primary.white,
      height: "56px",
    },

    "banner-container": {
      width: "100%",
    },

    ".banner2": {
      display: "block",
      borderRadius: "8px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      ".banner1img": {
        borderRadius: "8px",
        width: "90%",
      },
    },
    ".banner1": {
      display: "none",
    },
  },
}));

const BannerGeneric = ({
  bannerData = { desktopImg: "", mobileImg: "", altText: "Top Banner" },
}) => {
  // const navigate = useRouter();
  // const state = useContext(Context);
  //const { searchValue } = state;
  // const [bannerState, setBannerState] = useState({
  //   desktopImg: imagesWEBP?.vehiclePageBanner,
  //   mobileImg: imagesWEBP?.brandBanner,
  // });

  // useEffect(() => {
  //   if (bannerData) {
  //     setBannerState({
  //       desktopImg: bannerData?.desktopImg
  //         ? bannerData?.desktopImg
  //         : bannerData?.mobileImg,
  //       mobileImg: bannerData?.mobileImg
  //         ? bannerData?.mobileImg
  //         : imagesWEBP?.brandBanner,
  //     });
  //   } else {
  //     setBannerState({
  //       desktopImg: imagesWEBP?.vehiclePageBanner,
  //       mobileImg: imagesWEBP?.brandBanner,
  //     });
  //   }
  // }, [bannerData]);
  return (
    <CustomBanner>
      <Box className="banner-container">
        <Grid item lg={12} className="banner1">
          <LazyLoadImage
            visibleByDefault={true}
            src={bannerData?.desktopImg ?? imagesWEBP?.vehiclePageBanner}
            className="banner1img"
            alt={bannerData?.altText}
          />
        </Grid>

        <Grid item xs={12} className="banner2">
          <LazyLoadImage
            visibleByDefault={true}
            src={bannerData?.mobileImg ?? imagesWEBP?.brandBanner}
            className="banner1img"
            style={{ minHeight: "220px" }}
            alt={bannerData?.altText}
          />
        </Grid>
      </Box>
    </CustomBanner>
  );
};

const MemoizedTopBanner = React.memo(BannerGeneric);
export default MemoizedTopBanner;
